module.exports = __webpack_public_path__ + "img/bg_003.e8e7129f.png";